import React from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend } from "recharts";
import ChartContainer from "../chartcontainer/ChartContainer";

export default function UsageStackedBar({ data }) {
  const filteredData = data
    .filter((row) => row.video_usage_count + row.exercise_count)
    .sort((a, b) => a - b);

  return (
    <ChartContainer title="Usage by district" width="100%" height={600}>
      <BarChart
        data={filteredData}
        margin={{
          top: 20,
          right: 30,
          left: 20,
          bottom: 5,
        }}
      >
        <XAxis
          dataKey="dist_name"
          angle={-45}
          textAnchor="end"
          interval={0}
          height={80}
          tick={{ fontSize: 14 }}
        />
        <YAxis />
        <Tooltip />
        <Legend />
        <Bar dataKey="exercise_count" stackId="a" fill="#8884d8" />
        <Bar dataKey="video_usage_count" stackId="a" fill="#82ca9d" />
      </BarChart>
    </ChartContainer>
  );
}
